if (!customElements.get('collapsible-content-anchor')) {
  class CollapsibleContentAnchor extends HTMLElement {
    constructor() {
      super();
      this.onHashChange = this.onHashChange.bind(this);
    }

    connectedCallback() {
      window.addEventListener('hashchange', this.onHashChange);
      this.onHashChange();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHashChange);
    }

    onHashChange() {
      const hash = window.location.hash.slice(1);
      if (!hash) return;

      const target = document.getElementById(hash);
      if (!target || !this.contains(target)) return;

      const details = target.matches('details') ? target : target.querySelector('details');
      if (details && !details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    }
  }

  customElements.define('collapsible-content-anchor', CollapsibleContentAnchor);
}
